import { withStyles } from '@material-ui/core';
import BrandHeader from './BrandHeader';
import styles from './styles';

export default withStyles(styles)(BrandHeader);
